import { isMobile } from "@rio-cloud/rio-uikit/utils/deviceUtils";

const fixedColumnsValues = ["agendamento", "veiculo", "chassi", "odometro", "horimetro", "licensePlate", "accountName"];
const fixedColumnsMobileValues = ["veiculo"];

const scrollableColumnsValues = ["acoes", "revisoes", "score", "grupoManutencao", "statusGarantia", "rio", "status", "volksTotal", "ultimaRevisao", "proximaRevisao"];
const scrollableColumnsMobileValues = ["agendamento", "chassi", "odometro", "horimetro", "acoes", "revisoes", "score", "grupoManutencao", "statusGarantia", "rio", "status", "volksTotal", "ultimaRevisao", "proximaRevisao"];

const allColumns = [
    {
        value: "agendamento",
        label: 'Agendamento',
        details: { width: 60, defaultWidth: 60, maxWidth: 300 },
    },
    {
        value: "veiculo",
        label: 'Veículo',
        details: { width: 0, defaultWidth: 200, maxWidth: 350 },
    },
    {
        value: "chassi",
        label: 'Chassi',
        details: { width: 130, defaultWidth: 0, maxWidth: 350 },
    },
    {
        value: "odometro",
        label: 'Odômetro',
        details: { width: 0, defaultWidth: 0, maxWidth: 350 },
    },
    {
        value: "horimetro",
        label: 'Horímetro',
        details: { width: 0, defaultWidth: 0, maxWidth: 350 },
    },
    {
        value: "acoes",
        label: 'Campanhas de Campo',
        details: { width: 150, defaultWidth: 150, maxWidth: 150 },
    },
    {
        value: "revisoes",
        label: 'Revisões Periódicas',
        details: { width: 120, defaultWidth: 120, maxWidth: 150 },
    },
    {
        value: "score",
        label: 'Score',
        details: { width: 80, defaultWidth: 80, maxWidth: 130 },
    },
    {
        value: "grupoManutencao",
        label: 'Grupo Manutencao',
        details: { width: 130, defaultWidth: 130, maxWidth: 150 },
    },
    {
        value: "statusGarantia",
        label: 'Status Garantia',
        details: { width: 100, defaultWidth: 100, maxWidth: 100 },
    },
    {
        value: "status",
        label: 'Status',
        details: { width: 80, defaultWidth: 80, maxWidth: 100 },
    },
    {
        value: "rio",
        label: 'RIO',
        details: { width: 100, defaultWidth: 100, maxWidth: 100 },
    },
    {
        value: "volksTotal",
        label: 'Volks Total',
        details: { width: 100, defaultWidth: 100, maxWidth: 120 },
    },
    {
        value: "ultimaRevisao",
        label: 'Última Revisão',
        details: { width: 140, defaultWidth: 140, maxWidth: 160 },
    },
    {
        value: "proximaRevisao",
        label: 'Próxima Revisão',
        details: { width: 180, defaultWidth: 180, maxWidth: 200 },
    },
    {
        value: "licensePlate",
        label: 'Placa',
        details: { width: 0, defaultWidth: 0, maxWidth: 350 },
    },
    {
        value: "accountName",
        label: 'Conta',
        details: { width: 0, defaultWidth: 0, maxWidth: 350 },
    },
];

export const fixedColumns = allColumns.filter((column) => {
    if (isMobile()) return fixedColumnsMobileValues.includes(column.value);
    return fixedColumnsValues.includes(column.value);
});

export const scrollableColumns = allColumns.filter((column) => {
    if (isMobile()) return scrollableColumnsMobileValues.includes(column.value);
    return scrollableColumnsValues.includes(column.value);
});